/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/no-unresolved */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import "components/elements/main/index.scss";

import * as Actions from "actions";

import UserCombinedSearch from "components/widgets/user/UserCombinedSearch";

const UserCombinedSearchMain = (props) => {
  const [state] = useState({
    layoutColumns: 3,
  });

  useEffect(() => {
    props.userResetSearchProducts();
    document.getElementById("color").setAttribute("href", "#");
  }, []);

  return (
      <UserCombinedSearch {...props} colSize={state.layoutColumns} />
  );
};

UserCombinedSearchMain.propTypes = {
  userResetSearchProducts: PropTypes.func.isRequired,
};

// Mapping Props and State.
const userCombinedSearchMain = connect(
  ({ userproducts, bootupInfo }) => ({
    bootupInfo,
    reqStatus: userproducts.reqStatus,
    isLoading: userproducts.isLoading,
    serviceError: userproducts.serviceError,
  }),
  (dispatch) => bindActionCreators({ ...Actions }, dispatch),
)(UserCombinedSearchMain);

export default userCombinedSearchMain;
